import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { postUserLogin, Sync } from "../../../../api";
import Icon from "../../../../assets/icons";
import {
  useAuthContext,
  useLanguageContext,
  useThemeContext,
} from "../../../../context";
import { Button, CustomContainer, TextField } from "../../../common";
import Cookies from "js-cookie";

const Login = () => {
  const navigate = useNavigate();

  const { I18n } = useLanguageContext();
  const { theme } = useThemeContext();
  const { handleLoginInDB } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [viewPassword, setViewPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleRegister = () => {
    navigate("/register");
  };

  const onChange = (label, value) => {
    if (label === I18n.enter_username) {
      setUsername(value);
    } else if (label === I18n.enter_password) {
      setPassword(value);
    }

    setErrors({});
  };

  const handleLogin = () => {
    let paramsForApi = {
      username,
      password,
    };

    setIsLoading(true);

    postUserLogin(paramsForApi)
      .then(async (res) => {
        if (res?.status === 200 || res?.response?.status === 200) {
          const { user_id, access_token, login_session } = res.data;
          try {
            Cookies.set("access_token", access_token);
            await Sync(username);
            await handleLoginInDB(user_id, login_session);
            setIsLoading(false);
            navigate("/", { replace: true });
          } catch (err) {
            console.log("Something went wrong", err);
            setIsLoading(false);
          }
        } else {
          setErrors({ authError: res?.response?.data?.msg });
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err is", err);
        setIsLoading(false);
      });
  };

  const handleEnterPress = (event) => {
    if (
      event.key === "Enter" &&
      username &&
      password &&
      !Object.keys(errors).length
    ) {
      handleLogin();
    }
  };

  return (
    <CustomContainer
      handlePress={handleEnterPress}
      className="loginPageWrapper"
    >
      <div className="logoBox">
        <Icon
          name={"oscarLogo"}
          fill={"white"}
          viewBox={"0 0 115 110"}
          width={"55"}
          height={"50"}
        />
      </div>

      <Row className="justify-content-md-center">
        <Col md={5}>
          <div className="loginFormBox">
            <h1
              className="fontSize24 fontWeight700 marBot10 "
              style={{ color: theme.text }}
            >
              {I18n.login}
            </h1>

            <TextField
              onChange={onChange}
              label={I18n.enter_username}
              placeholder={I18n.enter_username}
              value={username}
              error={errors.username}
              required={true}
              autoFocus={true}
            />

            <TextField
              onChange={onChange}
              error={errors["authError"]}
              label={I18n.enter_password}
              placeholder={I18n.enter_password}
              value={password}
              required={true}
              type={viewPassword ? "text" : "password"}
            />

            <p className="fontSize14 cursorPointer marTop15 marBot15 barclaysBlueColor">
              {I18n.forgot_password}
            </p>

            <div className="signinLoginButton">
              <Button
                className={`width100 fontWeight600 fontSize16 cursorPointer`}
                title={I18n.login}
                saveLoad={isLoading ? true : false}
                handleClick={handleLogin}
              />
            </div>

            <div>
              <p className="fontSize14 marTop20">
                <span className="white">{I18n.new_to_oscar}</span>
                <span
                  className="cursorPointer  marLeft5 barclaysBlueColor"
                  onClick={handleRegister}
                >
                  {I18n.get_started}
                </span>
                <span className="marLeft5">
                  <Icon name="arrowRight" viewBox="0 0 18 18 " />
                </span>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </CustomContainer>
  );
};

export default Login;
